// Core
require('./core/index');

// Libs
require('./libs/core');

// Core functions created to Shopify
require('./partials/core.functions');

// Partials
require('./partials/mediamarkt');
require('./partials/global');
require('./partials/master.min');
//require('./partials/main/_cookiePolice');
require('./partials/main/_cookieLocation');
require('./partials/main/_mainCategoriesNav');
require('./partials/main/_customModal');
require('./partials/main/_topbarScroll');
require('./partials/main/_headerLinksScroll');
require('./partials/main/_mobileMenu');
